import {Injectable} from '@angular/core';
import {FormExtractorService} from 'src/app/modules/shared/services/form-extractor.service';
import {InitialService} from './service/initial/initial.service';
import {Avis} from 'src/app/models/avis';
import {FormsEnum} from 'src/app/models/enums/forms.enum';
import {Annonce} from '../../common/models/annonce';
import {StatutAvisEnum} from '../../../../models/enums/statut-avis.enum';
import {CommonService} from '../../common/services/common/common.service';
import {MAPA} from '../common/models/MAPA';
import {MapaService} from '../common/services/mapa/mapa.service';
import {TypeAvisEnum} from '../../../../models/enums/type-avis.enum';
import {AvisDataTransferService} from '../../../shared/services/avis-data-transfer.service';

@Injectable({
  providedIn: 'root'
})
export class FormmapaInitialExtractorService {

  constructor(private formExtractorService: FormExtractorService, private initialService: InitialService,
              private mapaService: MapaService,
              private commonService: CommonService,
              private avisDataTransferService: AvisDataTransferService) {
  }


  public mapFormToAvis(form, stepId, actualFormIdAnnEmetteur): Avis {

    const controls = this.formExtractorService.getMapControlsIdWithoutStepAndValue(form);


    const initial = this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.mapa.initialFromMAPA;
    if (stepId == 5) {
      initial.delaiUrgence = controls.get('_SepSep_Initial_SepAtt_delaiUrgence');
    }
    initial.marcheUnique = controls.get('_SepSep_Initial_SepAtt_marcheUnique');
    if (stepId == 12) {
      initial.adressesComplt = this.initialService.adressesCompltService.getAdressesComplt(controls, this.formExtractorService, stepId);
    }
    if (stepId == 3) {
      initial.caracteristiques = this.initialService.caracteristiquesService.getCaracteristiques(controls, this.formExtractorService);
    }
    if (stepId == 7) {
      initial.conditions = this.initialService.conditionsService.getConditions(controls, this.formExtractorService);
    }
    if (stepId == 9) {
      initial.criteres = this.initialService.criteresService.getCriteres(controls, this.formExtractorService);
    }
    if (stepId == 2) {
      initial.description = this.initialService.descriptionService.getDescription(controls, this.formExtractorService);
      initial.natureMarche = this.initialService.natureMarcheService.getNatureMarche(controls);
    }
    if (stepId == 6) {
      initial.duree = this.initialService.dureeService.getDuree(controls);
    }
    if (stepId == 11) {
      initial.adressesComplt = this.initialService.adressesCompltService.getAdressesComplt(controls, this.formExtractorService, stepId);
      initial.infosSup = this.initialService.infosSupService.getInfosSup(controls);
      initial.renseignements = this.initialService.renseignementsService.getRenseignements(controls);
    }
    if (stepId == 8) {
      initial.justifications = this.initialService.justificationsService.getJustifications(controls, this.formExtractorService);
    }
    if (stepId == 4) {
      initial.lots = this.initialService.lotsService.getLots(controls, this.formExtractorService);
      initial.isAlloti = controls.get('_SepSep_Initial_SepSep_TypeLotsMAPA_SepAtt_marcheAlloti');
    }
    initial.procedure = this.initialService.procedureService.getProcedure(controls);

    if (stepId == 10) {
      initial.delais = this.initialService.typeDelaisService.getTypeDelais(controls);
    }


    const mapa: MAPA = this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.mapa;
    if (stepId == 1) {
      mapa.organisme = this.mapaService.organismeService.getOrganisme(controls);
    }
    mapa.initialFromMAPA = initial;
    mapa.attributionFromMAPA = null;
    mapa.rectificatifFromMAPA = null;
    mapa.annulationFromMAPA = null;

    const annonce: Annonce = new Annonce();
    annonce.ann.idAnnEmetteur = actualFormIdAnnEmetteur;
    annonce.ann.divers = null;
    annonce.ann.mapa = mapa;
    annonce.ann.fnSimple = null;
    annonce.ann.formAD = null;
    annonce.ann.facturation = this.commonService.facturationService.getFacturation(form, 'DIV', controls);
    annonce.ann.indexation = this.commonService.indexationService.getIndexation(form);
    annonce.ann.dateEnvoi = controls.get('_SepSep_Annonce_index_1_SepSep_TypeAnn_SepAtt_dateEnvoi');

    annonce.annonceur.login = controls.get('_SepSep_idAnnonceur_SepAtt_idannonceurboampweb');
    annonce.annonceur.mail = controls.get('_SepSep_idAnnonceur_SepAtt_mailcontactboampweb');
    
    const avis: Avis = new Avis();
    avis.jsonSaisieFormulaire = annonce;
    avis.formulaire.code = FormsEnum[FormsEnum.MAPA_IN];
    avis.statut = StatutAvisEnum.ELABORE;
    avis.critere.typeAvis.code = TypeAvisEnum.C4_2;

    //Nettoyer les blocs inexistants
    avis.jsonSaisieFormulaire.ann.mapa.initialFromMAPA.procedure.procedureAdaptee = '';
    // avis.jsonSaisieFormulaire.ann.facturation.userChorus = { oui : null , non : false};
    avis.jsonSaisieFormulaire.ann.mapa.initialFromMAPA.caracteristiques.tabCar1 = null;
    avis.jsonSaisieFormulaire.ann.mapa.initialFromMAPA.caracteristiques.tabCarMinMax = null;
    return avis;
  }
}

